import {IncidentModel} from '../../models/api/incidentModel';

// Exclude incidents that are not impacting the current user.
export function filterVisibleIncidents(
  incidents: ReadonlyArray<IncidentModel>,
  ownLabels: ReadonlyArray<string>,
) {
  return incidents.filter((incident) => {
    const incidentLabels = [...parseIncidentLabels(incident.name), ...parseIncidentLabels(incident.body)];

    // If the incident has no labels, assume it affects all users.
    return (
      incidentLabels.length === 0 ||
      incidentLabels.every((parsedLabel) => {
        switch (parsedLabel.op) {
          case 'equals':
            return ownLabels.includes(parsedLabel.val);
          case 'or':
            return parsedLabel.val.some((label: string) => ownLabels.includes(label));
          default:
            return false;
        }
      })
    );
  });
}

/**
 * When filtering on company ids we want to clean up the incident body to remove the list of ids.
 */
export function cleanVisibleIncidents(incidents: ReadonlyArray<IncidentModel>) {
  const companyIdsLabelRegex = /\[[\d\-|]+\]/g; // Will only match labels targeting company ids - i.e. [123443], [123|45566].
  return incidents.map((incident) => {
    if (companyIdsLabelRegex.test(incident.body) || companyIdsLabelRegex.test(incident.name)) {
      return {
        ...incident,
        // For simplicity we update both properties.
        body: incident.body.replace(companyIdsLabelRegex, '').trim(),
        name: incident.name.replace(companyIdsLabelRegex, '').trim(),
      };
    }
    return incident;
  });
}

type IncidentLabel = {op: 'equals'; val: string} | {op: 'or'; val: string[]};

function parseIncidentLabels(string: string): IncidentLabel[] {
  const labelRegex = /\[([\w\-|]+)\]/g;
  let match;
  const labels: IncidentLabel[] = [];

  // eslint-disable-next-line
  while ((match = labelRegex.exec(string))) {
    const labelName = match[1].toLowerCase();

    if (labelName.includes('|')) {
      labels.push({op: 'or', val: labelName.split('|')});
    } else {
      labels.push({op: 'equals', val: labelName});
    }
  }

  return labels;
}
